import { Badge, Button, Card, CardBody, Col, Dropdown, Form, Modal, Row, Stack } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import Api from "../../../api/Api";
import { useState } from "react";
import { getUserData } from "../../reuse/getUserRole";

const ModalDeleteWarning = ({data}) => {
    const [show, setShow] = useState(false);
    const [fieldType,setFieldType]=useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const deleteAudit = async(audit_id, password) => {
        try {
            const response = await Api({
                method:"delete",
                url:`/audits/@${audit_id}`,
                headers:{password:password}
            })
            alert("Аудит удалён из системы");
            window.location.reload();
        } catch (error) {
            alert(`Ошибка при удалении аудита. \n ${error}`);
        }
    }

    const handleDelete = async() => {
        const password=document.getElementById("password_data_delete").value;
        if (password!=="" && password!==null){
            await deleteAudit(data.id, password)
        }else{
            alert("Введите пароль!")
        }
    }

    return(
        <>
            <Dropdown.Item onClick={handleShow}>Удалить</Dropdown.Item>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title className="text_font">Внимание</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Text className="text_font">Вы уверены, что хотите удалить аудит "{data.name}" из системы? После удаления, его нельзя будет восстановить!</Form.Text>
                    <Form.Control 
                    id="password_data_delete"
                    placeholder="Для подтверждения введите пароль пользователя..." 
                    required 
                    type={fieldType ? "text" : "password"}/>
                    <Form.Check 
                    checked={fieldType}
                    onChange={(e)=>setFieldType(e.target.checked)}
                    type="switch" 
                    label="Скрыть/показать пароль"></Form.Check>
                    <Row className="mt-2">
                        <Col>
                            <Button 
                            variant="light" 
                            className="free-btn"
                            onClick={handleClose}>Отмена</Button> 
                        </Col>
                        <Col>
                            <Button variant="danger" className="free-btn" onClick={()=>handleDelete()}>Да, удалить</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}


const ModalArchiveWarning = ({data}) => {
    const [show, setShow] = useState(false);
    const [fieldType,setFieldType]=useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const archiveAudit = async(audit_id, password) => {
        try {
            const response = await Api({
                method:"post",
                url:`/audits/@${audit_id}/archive`,
                headers:{password:password}
            })
            alert(`Аудит архивирован`);
            window.location.reload();
        } catch (error) {
            alert(`Ошибка при архивации аудита. \n ${error}`)
        }
    }

    const handleArchive = async() => {
        const password=document.getElementById("password_data_arc").value;
        if (password!=="" && password!==null){
            await archiveAudit(data.id, password);
        }else{
            alert("Введите пароль!");
        }
    }

    return(
        <>
            <Dropdown.Item onClick={()=>{handleShow()}}>Архивировать</Dropdown.Item>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title className="text_font">Архив</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Text className="text_font">Вы уверены, что хотите архивировать аудит "{data.name}"?</Form.Text>
                    <Form.Control 
                    id="password_data_arc"
                    type={fieldType ? "text" : "password"}
                    placeholder="Для архивации аудита введите пароль пользователя..." 
                    required />
                    <Form.Check 
                    checked={fieldType}
                    onChange={(e)=>setFieldType(e.target.checked)}
                    type="switch" 
                    label="Скрыть/показать пароль"></Form.Check>
                    <Row className="mt-2">
                        <Col>
                            <Button 
                            variant="light" 
                            className="free-btn"
                            onClick={handleClose}>Отмена</Button> 
                        </Col>
                        <Col>
                            <Button 
                            onClick={()=>handleArchive()}
                            className="free-btn" >Да, подтвердить</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}

const AuditCard = ({audit}) => {
    const type_variants={
        [true]:{name:"Активный", color:"custom_badge_success"},
        [false]:{name:"Неактивный", color:"custom_badge_secondary"}}
    const type_audit={
        common:"Обычный",
        "self-esteem":"Самоаудит"
    }

    const changeStatus = async(audit_id,is_active) =>{
        try {
            const response = await Api({
                method:"post",
                url:`/audits/@${audit_id}/set_active/${!is_active}`,
                headers:{}
            })
            window.location.reload();
        } catch (error) {
            alert(`Ошибка при изменении статуса аудита \n ${error}`);
        }
    }

    const handleChangeStatus = async() => {
        await changeStatus(audit.id,audit.is_active);
    }

    const handleAuditPage = () => {
        if(audit.is_active){
            window.location.href=`/audit_page/${audit.id}`;
        }else{
            alert("Аудит не активирован. Доступ отсутствует")
        }
    }

    return(
        <>
        <Card className="mt-3 audit_card_block">
            <CardBody>
                <div>
                    <Stack direction="horizontal">
                        <div className="text_font">{new Date(audit.start_datetime).toLocaleDateString()} - {new Date(audit.end_datetime).toLocaleDateString()}</div>
                        <div className="ms-auto">
                            <Dropdown align="end">
                            <Dropdown.Toggle variant="light border" id="dropdown-basic">
                                <BsThreeDotsVertical />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {audit.is_active && <Dropdown.Item href={`/audit_page/${audit.id}`}>Выбрать</Dropdown.Item>}
                                {audit.results_access && <Dropdown.Item href={`/audit_result_page/${audit.id}`}>Посмотреть результаты</Dropdown.Item>}
                                {audit.change_activity && <Dropdown.Item onClick={()=>{handleChangeStatus()}}>Изменить статус</Dropdown.Item>}
                                {!(new Object(getUserData()).role in ["Admin","Admin-RO", "Moderator"]) ? 
                                <div>
                                <Dropdown.Item href={`/change_audit/${audit.id}`}>Редактировать</Dropdown.Item>
                                <ModalArchiveWarning data={{name:audit.name, id:audit.id}}/>
                                <ModalDeleteWarning data={{name:audit.name, id:audit.id}}/>
                                </div> : null
                                }
                            </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </Stack>
                </div>
                <div onClick={()=>handleAuditPage()} style={{cursor:"pointer"}}>
                    <div >
                        <Stack direction="horizontal" gap={1}>
                            <div className={type_variants[audit.is_active].color}>{type_variants[audit.is_active].name}</div>
                            <div className="custom_badge_secondary">{type_audit[audit.audit_type]}</div>
                        </Stack>
                    </div>
                    <div>
                        <div className="text_font">Завод: {audit.facility}</div>
                        <div className="text_font audit_card_block_text">{audit.name}</div>
                    </div>
                </div>
            </CardBody>
        </Card>
        </>
    )
}

export default AuditCard;